import { CheckCircle2, Clock, XCircle } from "lucide-react";
import { cn } from "@/lib/cn";

type Status = "PENDING" | "VERIFIED" | "REJECTED";

const STYLES: Record<Status, { label: string; className: string; icon: typeof Clock }> = {
  PENDING: {
    label: "Aguardando verificação",
    className: "bg-amber-50 text-amber-700 border-amber-200",
    icon: Clock,
  },
  VERIFIED: {
    label: "Verificado",
    className: "bg-green-50 text-green-700 border-green-200",
    icon: CheckCircle2,
  },
  REJECTED: {
    label: "Rejeitado",
    className: "bg-red-50 text-red-700 border-red-200",
    icon: XCircle,
  },
};

export function CroStatusBadge({ status }: { status: Status }) {
  const { label, className, icon: Icon } = STYLES[status];
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium",
        className,
      )}
    >
      <Icon className="h-3 w-3" />
      {label}
    </span>
  );
}
